import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/global';

export const PREFERENCE_FETCH_START = 'LITIGATION/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS = 'LITIGATION/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'LITIGATION/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START = 'LITIGATION/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS =
  'LITIGATION/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR = 'LITIGATION/PREFERENCE_PERSIST_ERROR';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);

export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);

export const SELECT_ARBITRATOR_RECORD = 'LITIGATION/SELECT_ARBITRATOR_RECORD';

export function selectArbitratorRecord(arbitratorID) {
  return async dispatch => {
    dispatch({ type: SELECT_ARBITRATOR_RECORD, data: arbitratorID.toString() });
  };
}
